// @flow
import _get from 'lodash/get'
import { cleanString } from './cleanString'
type PageContent = {
  title: string,
  items: Array<PageItems>
}

type PageItems = {
  title: string,
  body: string
}

export const contentHasHeadings = (content:string):boolean => {
  const parser = new DOMParser().parseFromString(content, 'text/html')
  return ['h1', 'h2', 'h3', 'h4']
    .map(tag => parser.querySelectorAll(tag).length)
    .reduce((accumulator, currentValue) => accumulator + currentValue , 0) > 0
}

export const parseContentWithHeadings = page => {
  const parser = new DOMParser().parseFromString(page.content, 'text/html')
  const headers = [`h1`, `h2`, `h3`, `h4`]
    .map(headerTag => parser.querySelectorAll(headerTag))
    .reduce((tag, accumulator) => Array.from(accumulator).concat(tag), [])

  return {
    title: page.title,
    items: headers.reduce(innerContentProcessor, [])
      .filter(item => item.body.length !== 0)
  }
}

export const innerContentProcessor = (accumulator, innerContentElement) => {
  accumulator.push({
    title: (elementIsHeading(innerContentElement)) ? cleanString(innerContentElement.textContent).trim() : null,
    body: processTextBlock(innerContentElement, [])
      .map(element => {
        return (!!element) ? cleanString( element.outerHTML || element.textContent).trim() : null
      })
      .join(' ').trim()
  })
  return accumulator
}

const elementIsHeading = (element):boolean => ([`H1`, `H2`, `H3`, `H4`, `H5`, `H6`].includes(_get(element, 'tagName')))

export const processTextBlock = (element:HTMLElement, collection:Array<HTMLElement>):Array<HTMLElement> => {
  if (element === null) return collection
  if (elementIsHeading(element.nextSibling)) return collection
  collection.push(element.nextSibling)
  return processTextBlock(element.nextSibling, collection)
}

const blankPage = {
  title: '404',
  items: [{
    title: '',
    body: 'Content not found'
  }]
}

export const getPageContent = (wordPressPages, key):PageContent => {
  let page = Object.keys(wordPressPages)
    .map(id => wordPressPages[id])
    .find(x => x.key === key)

  if (!page) {
    return null
  }

  return (contentHasHeadings(page.content))
    ? parseContentWithHeadings(page)
    : blankPage
}
